import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { styled } from 'styles';

export const StyledScrollArea = styled(OverlayScrollbarsComponent)`
  width: 100%;
`;

StyledScrollArea.displayName = 'ScrollArea.Styled';
